/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Allowed save status values.
 */
export enum SaveStatus {
  SAVING = 'saving',
  SAVED = 'saved',
  RETRYING_SAVE = 'retrying save',
  ERROR = 'error',
  REVISION_MISMATCH = 'revision mismatch',
}

/**
 * Service to store/broadcast data/statuses related to the save module.
 */
@Injectable({
  providedIn: 'root',
})
export class SaveStateStore {

  public status$ : BehaviorSubject<SaveStatus>;

  /**
   * Default Constructor.
   */
  constructor() {
    this.status$ = new BehaviorSubject(SaveStatus.SAVED);
  }

  /**
   * Method to update and broadcast a new status.
   * @param status New status value.
   * @private
   */
  public setStatus(status : SaveStatus) {
    this.status$.next(status);
  }

  /**
   * Helper method to get the enum for Javascript users of this class.
   */
  // eslint-disable-next-line class-methods-use-this
  public getStatusEnum() {
    return SaveStatus;
  }
}
